import { MouseEvent } from 'react';

import type { HelpPageContent } from 'components/help_sidebar/HelpSidebar';
import { useHelpSidebar } from 'components/help_sidebar/context';
import { Button, ButtonProps } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

import 'components/help_sidebar/components/trigger/styles/HelpSidebarTrigger.scss';

type HelpSidebarTriggerProps = Omit<ButtonProps, 'content'> & {
    content: HelpPageContent;
    icon?: string;
}

export const HelpSidebarTrigger = (props: HelpSidebarTriggerProps) => {

    const { formatMessage } = useIntl();

    const { className, content, icon = 'fa-solid fa-question-circle', onClick, size = 'lg', variant = 'outline-primary', ...rest } = props;

    const { isFeatureEnabled } = useApp();
    const { show, visible } = useHelpSidebar();

    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {

        show(content);
        onClick?.(e);

    };

    if (!isFeatureEnabled('Admin.General.HelpSidebar')) return null;

    return (
        <Button
            aria-expanded={visible}
            aria-label={formatMessage({ id: 'open_help_sidebar.debff65e', defaultMessage: 'Open help sidebar' })}
            className={`help-sidebar-trigger ${className ?? ''}`.trim()}
            onClick={handleClick}
            size={size}
            variant={variant}
            {...rest}
        >
            <i aria-hidden={'true'} className={icon}/>
        </Button>
    );

};